module.exports = "<div class=\"mycard\">\n    <p class=\"add\">Add New Board</p>\n</div>"